import { Box, FormControl, TextField, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import * as React from 'react';
import { ChangeEvent, useCallback } from 'react';
import { useSnapshot } from 'valtio';
import {
  setHostUrlErrorMsg,
  setHostUrlValidationError,
} from '../actions/connector-configure-actions';
import { IConnectorHostURLProps } from '../connectors-types';
import ConnectorConfigureStore from '../stores/connector-configure-store';
import { isValidHttpUrl } from '../../common/common-utils';

const ConnectorHostURL: React.FunctionComponent<
  React.PropsWithChildren<IConnectorHostURLProps>
> = props => {
  const { name, value, onChange, isDisabled, hasError } = props;
  const {
    hostUrlErrorMsg: validationErrMsg,
    hostUrlValidationError: validationError,
  } = useSnapshot(ConnectorConfigureStore);

  React.useEffect(() => {
    return () => {
      setHostUrlValidationError(false);
      setHostUrlErrorMsg('');
    };
  }, []);
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value: eventValue } = event.target;
      const urlIncludesHttpOrHttps =
        eventValue.startsWith('http') || eventValue.startsWith('https');

      if (!urlIncludesHttpOrHttps) {
        setHostUrlErrorMsg('Host URL must start with either HTTP or HTTPS');
      }

      const isValidURL = isValidHttpUrl(eventValue);
      if (!isValidURL && urlIncludesHttpOrHttps) {
        setHostUrlErrorMsg('Host URL must be a valid URL');
      }
      const invalidInput = !isValidURL || !urlIncludesHttpOrHttps;
      setHostUrlValidationError(invalidInput);
      ConnectorConfigureStore.invalidForm = invalidInput;
      onChange(event);
    },
    [onChange],
  );
  const { classes } = useStyles();
  return (
    <Box display='flex' mb={3} alignItems='center'>
      <FormControl className={classes.fullWidth}>
        <TextField
          autoComplete='off'
          size='small'
          required
          type='text'
          label={`${name} Host URL`}
          value={value}
          error={hasError || validationError}
          onChange={handleChange}
          name='hostURL'
          disabled={isDisabled}
          fullWidth
          helperText={validationError ? validationErrMsg : ''}
        />
      </FormControl>
    </Box>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  fullWidth: {
    width: '100%',
  },
}));

export default ConnectorHostURL;
